import { PageHeader } from '@/shared/components/ui/PageHeader';
import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { Radar } from 'lucide-react';
import { ScrapeConfigForm } from '../components/ScrapeConfigForm';
import { LiveSession } from '../components/LiveSession';
import { JobHistory } from '../components/JobHistory';
import { useScrapeStream } from '../hooks/useScrapeStream';
import type { ScrapeParams } from '../types';

export function ScraperPage() {
  const stream = useScrapeStream();
  const [lastMax, setLastMax] = useState(20);

  const handleStart = (params: ScrapeParams) => {
    if (stream.isActive) {
      toast.error('A scan is already running.');
      return;
    }
    setLastMax(params.maxResults);
    stream.start(params);
  };

  return (
    <div className="flex h-full flex-col gap-4 pb-16">
      <PageHeader
        icon={Radar}
        eyebrow="Marketing"
        title="Lead Generation"
        description={<>Scrape business leads and track every scan.</>}
      />

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <ScrapeConfigForm disabled={stream.isActive} onStart={handleStart} />
        <LiveSession stream={stream} onStop={stream.stop} maxResults={lastMax} />
      </div>

      <JobHistory />
    </div>
  );
}
